import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ToolbarWrapper } from './styles';
import { styled } from '../../styles';
import { Row } from '../layout';
import { TextEmphasisToolset } from './text_emphasis_toolset';
import { LinkButton } from './link_button';
import { TextHeadingDropdown } from './text_heading_dropdown';
import { ListsToolset } from './list_toolset';
import { DividerButton } from './divider_button';
export function InCallToolbar() {
    return (_jsx(ToolbarWrapper, { padding: "0.5rem", height: "3.25rem", "data-testid": "notes-in-call-toobar", children: _jsxs(FormatButtons, { children: [_jsx(TextHeadingDropdown, {}), _jsx(TextEmphasisToolset, { paddingLR: inCallControlPadding }), _jsx(ListsToolset, { paddingLR: inCallControlPadding }), _jsx(DividerButton, {}), _jsx(LinkButton, { paddingLR: inCallControlPadding })] }) }));
}
const inCallControlPadding = '.25rem';
const FormatButtons = styled(Row)();
//# sourceMappingURL=in_call_toolbar.js.map